module.exports = __webpack_public_path__ + "static/media/spotify.fb4986f4.svg";